import api from './api';

const paymentService = {
  // Initiate ticket payment
  initiateTicketPayment: (data) => api.post('/user/payment/initiate', data),

  // Get user orders
  getMyOrders: () => api.get('/user/orders'),

  // Get user tickets
  getMyTickets: () => api.get('/user/tickets'),

  // Get ticket details
  getTicketDetails: (ticketId) => api.get(`/user/tickets/${ticketId}`),
};

export default paymentService;

